import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface LayoutStore {
  // State
  sidebarCollapsed: boolean
  sidebarWidth: number // pixels

  // Actions
  setSidebarCollapsed: (collapsed: boolean) => void
  toggleSidebar: () => void
  setSidebarWidth: (width: number) => void
}

// Allotment uses pixel values
const DEFAULT_SIDEBAR_WIDTH = 280 // pixels
const MIN_SIDEBAR_WIDTH = 200
const MAX_SIDEBAR_WIDTH = 500

export const useLayoutStore = create<LayoutStore>()(
  devtools(
    persist(
      (set) => ({
        sidebarCollapsed: false,
        sidebarWidth: DEFAULT_SIDEBAR_WIDTH,

        setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),

        toggleSidebar: () =>
          set((state) => ({
            sidebarCollapsed: !state.sidebarCollapsed,
          })),

        setSidebarWidth: (width) =>
          set({
            sidebarWidth: Math.max(MIN_SIDEBAR_WIDTH, Math.min(MAX_SIDEBAR_WIDTH, width)),
          }),
      }),
      {
        name: 'ecosemantic-layout',
        partialize: (state) => ({
          sidebarCollapsed: state.sidebarCollapsed,
          sidebarWidth: state.sidebarWidth,
        }),
      },
    ),
    { name: 'layout-store' },
  ),
)

// Export constants for use in components (pixel values for Allotment)
export const SIDEBAR_CONSTRAINTS = {
  defaultWidth: DEFAULT_SIDEBAR_WIDTH,
  minWidth: MIN_SIDEBAR_WIDTH,
  maxWidth: MAX_SIDEBAR_WIDTH,
} as const
